import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AddGuardian.css';
import PageHeader from './PageHeader';
import AxiosPost from '../http/Axios';

const AddGuardian = (props) => {
  const [guardianData, setGuardianData] = useState({
    familyId: '',
    firstName: '',
    lastName: '',
    email: '',
    relationshipToChild: '',
    primaryPhone: '',
    familyEmail: '',
    isPrimaryIndicator: 'N',
    zipCode: '',
    notes: '',
  });

  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [phone, setPhone] = useState('');

  const queryParams = new URLSearchParams(location.search);
  const loggedInAs = sessionStorage.getItem("loggedInAs") || "admin";
  const guid = queryParams.get('guid');
  const familyEmail = queryParams.get('familyEmail');
  const familyId = queryParams.get('familyId');
  const familyName = queryParams.get('familyName');

  console.log(guid);
  console.log(familyEmail);
  console.log(familyId);

  useEffect(() => {
    setGuardianData((prevData) => ({
      ...prevData,
      familyEmail: familyEmail || '',
    }));
  }, [familyEmail]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGuardianData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const guardianPostData = {
      familyId: familyId,
      firstName: guardianData.firstName,
      lastName: guardianData.lastName,
      email: guardianData.email,
      relationshipToChild: guardianData.relationshipToChild,
      primaryPhone: guardianData.primaryPhone,
      registeredIndicator: 'Y',
      registeredDate: new Date(),
      disabledIndicator: 'N',
      createdDate: new Date(),
      createdBy: loggedInAs,
      modifiedDate: new Date(),
      modifiedBy: loggedInAs,
      familyEmail: guardianData.familyEmail,
      isPrimaryIndicator: guardianData.isPrimaryIndicator,
      zipCode: guardianData.zipCode,
      notes: guardianData.notes,
    };

    console.log(guardianPostData);

    try {
      const response = await AxiosPost(
        process.env.REACT_APP_ADMIN_SERVICE + '/guardians',
        guardianPostData
      );
      console.log('Guardian data submitted successfully:', response.data);

      const familyDetailsPath = '/family-details-page';

      navigate(
        `${familyDetailsPath}?guid=${guid}`
      );
    } catch (error) {
      console.error('Error submitting guardian data:', error);
    }
  };

  const handleCancel = () => {
    const familyDetailsPath = '/family-details-page';

    navigate(
      `${familyDetailsPath}?guid=${guid}`
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setGuardianData((prevData) => ({ ...prevData, [name]: value }));
  };

  const formatPhoneNumber = (value) => {
    // Remove all non-digit characters
    const cleaned = ('' + value).replace(/\D/g, '');
    // Check if the cleaned string has at least 10 digits
    if (cleaned.length >= 10) {
      // Format the phone number as (xxx) xxx-xxxx
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
    return cleaned;
  };

  const handlePhoneChange = (event) => {
    const formattedPhone = formatPhoneNumber(event.target.value);
    setPhone(formattedPhone);
    setGuardianData((prevData) => ({
      ...prevData,
      primaryPhone: formattedPhone,
    }));
  };

  return (
    <div className="dashboard anding-page">
      <PageHeader title={familyName ? `The ${familyName} Family: Add Guardian` : "Add Guardian"} />


      <main className="page-content">
        <div>
          <form onSubmit={handleSubmit}>
            <div className="guardian-section">
              <div className="guardian-input-grid">
                <br />
                <br />

                <div className="guardian-input-group">
                  <label htmlFor="firstName">
                    First name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={guardianData.firstName}
                    onChange={handleInputChange}
                    required
                    maxLength="31"
                    pattern="[a-zA-Z .'-]+"
                    title="Guardian first name should only contain letters, period, apostrophe, hyphen/dash/em-dash, quotes, and spaces."
                    className="guardian-input-size"
                  />
                  {errors.firstName && (
                    <p className="error-message">{errors.firstName}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="lastName">
                    Last name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={guardianData.lastName}
                    onChange={handleInputChange}
                    required
                    maxLength="31"
                    pattern="[a-zA-Z .'-]+"
                    title="Guardian last name should only contain letters, period, apostrophe, hyphen/dash/em-dash, quotes, and spaces."
                    className="guardian-input-size"
                  />
                  {errors.lastName && (
                    <p className="error-message">{errors.lastName}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="guardianEmail">
                    Email <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={guardianData.email}
                    onChange={handleInputChange}
                    required
                    maxLength="99"
                    pattern="^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    title="Email should contain uppercase and lowercase Latin letters A to Z, digits 0 to 9, and printable characters !#$%&'*+-/=?^_`{|}~. It should not start or end with a dot or have consecutive dots."
                    className="guardian-input-size"
                  />
                  {errors.email && (
                    <p className="error-message">{errors.email}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="zipCode">
                    Zip code <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="zipCode"
                    value={guardianData.zipCode}
                    onChange={handleInputChange}
                    required
                    maxLength="5"
                    placeholder="#####"
                    pattern="\d{5}"
                    title="Zip Code should contain 5 digits only."
                    className="guardian-input-size"
                  />
                  {errors.zipCode && (
                    <p className="error-message">{errors.zipCode}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="primaryPhone">
                    Phone <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="primaryPhone"
                    value={guardianData.primaryPhone}
                    onChange={handlePhoneChange}
                    required
                    maxLength="14"
                    placeholder="(###) ###-####"
                    pattern="\(\d{3}\) \d{3}-\d{4}"
                    title="Primary phone number must be in the format: (123) 456-7890."
                    className="guardian-input-size"
                  />
                  {errors.primaryPhone && (
                    <p className="error-message">{errors.primaryPhone}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="relationshipToChild">
                    Relationship to child{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="relationshipToChild"
                    value={guardianData.relationshipToChild}
                    onChange={handleInputChange}
                    required
                    className="guardian-input-size"
                  >
                    <option value="">Select Relationship</option>
                    <option value="Mother">Mother</option>
                    <option value="Father">Father</option>
                    <option value="Grandmother">Grandmother</option>
                    <option value="Grandfather">Grandfather</option>
                    <option value="Sibling">Sibling</option>
                    <option value="Cousin">Cousin</option>
                    <option value="Stepmother">Stepmother</option>
                    <option value="Stepfather">Stepfather</option>
                    <option value="Aunt">Aunt</option>
                    <option value="Uncle">Uncle</option>
                    <option value="Nanny">Nanny</option>
                    <option value="Foster Mother">Foster Mother</option>
                    <option value="Foster Father">Foster Father</option>
                    <option value="Guardian">Guardian</option>
                    <option value="Other">Other</option>
                  </select>
                  {errors.relationshipToChild && (
                    <p className="error-message">
                      {errors.relationshipToChild}
                    </p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="isPrimaryIndicator">
                    Is primary? <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    name="isPrimaryIndicator"
                    value={guardianData.isPrimaryIndicator}
                    onChange={handleInputChange}
                    required
                    className="guardian-input-size"
                  >
                    <option value="Y">Y</option>
                    <option value="N">N</option>
                  </select>
                  {errors.isPrimaryIndicator && (
                    <p className="error-message">{errors.isPrimaryIndicator}</p>
                  )}
                </div>

                <div className="guardian-input-group">
                  <label htmlFor="notes">Notes</label>
                  <textarea
                    name="notes"
                    value={guardianData.notes}
                    onChange={handleInputChange}
                    maxLength="1024"
                    placeholder=""
                    className="guardian-input-size"
                    rows="3"
                  />
                  {errors.notes && <p className="error-message">{errors.notes}</p>}
                </div>

                <div className="button-group">
                  <button type="submit" className="submit-button">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="cancel-button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddGuardian;
